import styled from 'styled-components'
import { breakpoint } from '@configs/utilities'

export const ContentWrapper = styled.div`
  max-width: 2560px;
  margin: 0 auto;
`

export const GlobalPadding = styled.div`
  max-width: 1380px;
  padding: 0 20px;
  margin: 0 auto;

  @media screen and (min-width: ${breakpoint.md}) {
    padding: 0 30px;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    padding: 0 60px;
  }
`

export const HeadingCustomWrapper = styled.div`
  @media screen and (min-width: ${breakpoint.xl}) {
    max-width: 520px;
  }
`
